import { Box, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import { StyledCard, StyledCardContent } from "./styles";
import { NotificationCardProps, SeenNotificationResponse } from "./types";
// import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread';
import DeleteIcon from '@mui/icons-material/Delete';
import { API_URL } from "../../utils/common";
import swal from "sweetalert";

const NotificationCard: React.FC<NotificationCardProps> = ({title, message, id, callback}) => {
    const theme = useTheme();

    const handleMarkAsRead = (id: number) => {
        swal({title: "¿Estás seguro de que deseas eliminarla?", icon: "warning", buttons: [true, true], dangerMode: true})
        .then((willDelete) => {
            if (willDelete) {
                const token = localStorage.getItem("jwt");
                const user = localStorage.getItem("user");
                if (user){
                    const userObject = JSON.parse(user);
                    const data = {
                        nombreUsuario: userObject['username'].split('@')[0],
                        notificationId: id
                    }
                    fetch(`${API_URL}/notificaciones/visto`, {
                        method: "POST",
                        body: JSON.stringify(data),
                        headers: {
                          Authorization: `bearer ${token}`,
                          "content-type": "application/json",
                        },
                    })
                    .then((res) => res.json())
                    .then((response: SeenNotificationResponse) => {
                        callback();
                    })
                    .catch((err) => {
                        console.error(err);
                    });
                }
            }
        });
    }

    return (
        <StyledCard theme={theme}>
            <StyledCardContent theme={theme}>
                <Box display="flex" justifyContent="space-between">
                    <Box>
                        <Typography variant="body2">
                            {title}
                        </Typography>
                        <Typography variant="body2">
                            {message}
                        </Typography>
                    </Box>
                    <Tooltip title="Eliminar Notificación">
                        <IconButton onClick={() => handleMarkAsRead(id)}>
                            <DeleteIcon/>
                        </IconButton>
                    </Tooltip>
                </Box>
            </StyledCardContent>
        </StyledCard>
    )
}

export default NotificationCard;
